const state = {
    currentTab: null
};

const getters = {
    selectedTab: (state) => state.currentTab
};

const mutations = {
    setSelectedTab: (state, val) => state.currentTab = val,
};

export default {
    state,
    getters,
    mutations,
}